var _rect, _path, _circle, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgScriptCommands = function SvgScriptCommands(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.773,
    y: 0.78,
    width: 22.44,
    height: 22.44,
    rx: 6,
    fill: "url(#script-commands_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.71 14.32V9.68L14.32 12l-3.61 2.32Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6.445,
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "script-commands_svg__a",
    x1: 0.773,
    y1: 0.78,
    x2: 23.212,
    y2: 23.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D72A2A"
  })))));
};

export default SvgScriptCommands;